var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecordings({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.79 15.7899C4.5 15.7899 1 12.3 1 7.99997C1 3.69997 4.49 0.209961 8.79 0.209961C13.09 0.209961 16.58 3.69997 16.58 7.99997C16.58 12.3 13.09 15.7899 8.79 15.7899ZM8.79 0.869965C4.85 0.869965 1.65 4.06995 1.65 8.00995C1.65 11.9499 4.85 15.15 8.79 15.15C12.73 15.15 15.93 11.9499 15.93 8.00995C15.93 4.06995 12.73 0.869965 8.79 0.869965ZM13.4 10.4799C13.05 10.66 12.63 10.64 12.3 10.42L10.74 9.53995V9.62994C10.74 10.5199 10.01 11.25 9.12 11.25H5.88C4.99 11.25 4.26 10.5199 4.26 9.62994V6.38995C4.26 5.49995 4.99 4.76996 5.88 4.76996H9.12C10.01 4.76996 10.74 5.49995 10.74 6.38995V6.47995L12.29 5.60995C12.47 5.47995 12.69 5.40997 12.91 5.40997C13.08 5.40997 13.25 5.44997 13.41 5.52997C13.77 5.71997 13.99 6.07996 13.99 6.48996V9.51996C13.99 9.91996 13.77 10.29 13.41 10.4799H13.4ZM10.08 6.37994C10.08 5.83994 9.64 5.40997 9.11 5.40997H5.87C5.33 5.40997 4.9 5.84994 4.9 6.37994V9.61996C4.9 10.16 5.34 10.59 5.87 10.59H9.11C9.65 10.59 10.08 10.15 10.08 9.61996V6.37994ZM13.33 6.48996C13.33 6.32996 13.24 6.17996 13.1 6.10995C12.96 6.02995 12.79 6.04997 12.63 6.15997L10.74 7.22995V8.79996L12.63 9.86996L12.66 9.88995C12.79 9.97995 12.96 9.99995 13.1 9.91995C13.24 9.83995 13.33 9.69995 13.33 9.53995V6.50995V6.48996Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordings);
export default __webpack_public_path__ + "static/media/recordings.41f905d509114f0b84d5a326f53eb9fb.svg";
export { ForwardRef as ReactComponent };